import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Row, Col, CardBody, Card, Progress } from "reactstrap";
import { withRouter, Link } from "react-router-dom";

import { connect } from "react-redux";
import { getProfile } from "../../store/auth/profile/actions";
import { AvForm, AvField } from "availity-reactstrap-validation";

//Import Components
import LineChart from "./line-chart";
import RevenueChart from "./revenue-chart";
import SalesAnalytics from "./sales-analytics";
import DeviceAnalytics from "./devices";
import Products from "./product";
import LatestTransaction from "./latest-transaction";

//Import Image
import Revenue from "./Revenue";
import { get } from "../../helpers/api_helper";
import Utils from "../Utility";
const { io } = require("socket.io-client");

const Dashboard = (props) => {
  const { user } = props;
  const [data, setData] = useState(undefined);
  const [screens, setScreens] = useState([]);
  const [registeredUser, setRegisteredUser] = useState(0);
  const [unregisteredUser, setUnregisteredUser] = useState(0);
  const [ramCounter, setRamCounter] = useState(0);
  const [time, setTime] = useState(1);
  const [weekRegisterd, setWeekRegistered] = useState(0);
  const [weekUnregistered, setWeekUnregistered] = useState(0);
  const [cities, setCities] = useState([]);
  const [devices, setDevices] = useState([]);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    if (user) {
      getData();
    }
  }, [user]);

  console.log('user',user)

  const getData = () => {
    get("/category/count", { token: user?.token })
      .then((json) => {
        // console.log('response from get project list', json);
        if (json?.statusCode == 200) {
          setData(json?.data);
        }
      })
      .catch((error) => {
        console.log("error while getting project list", error);
      });
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Row>
          <div className="col-12">
            <div className="page-title-box d-flex align-items-center justify-content-between">
              <h4 className="page-title mb-0 font-size-18">Dashboard</h4>

              <div className="page-title-right">
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active">
                    Welcome to {Utils.projectName} Dashboard
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </Row>
        {/* <Row style={{ justifyContent: 'right' }}>
          <Col lg={2}>
            <div style={{ width: '100%' }}>
              <AvForm stye={{ float: 'right' }}>
                <AvField
                  type="select"
                  name="time"
                  label={"Time"}
                  value={time}
                  onChange={(e) => setTime(e.target.value)}
                >
                  <option value={1}>Today</option>
                  <option value={2}>Yesterday</option>
                  <option value={7}>Last 7 Days</option>
                  <option value={15}>Last 15 Days</option>
                  <option value={30}>Last 30 Days</option>
                  <option value={180}>Last 6 Month</option>
                  <option value={365}>Last 1 Year</option>
                </AvField>
              </AvForm>
            </div>
          </Col>
        </Row> */}
        {/* <Row className="mt-2">
          <Col lg={12}>
            <LineChart data={screens} />
          </Col>
        </Row> */}
        <Row>
          <Col lg={3}>
            <Card style={{ height: '87%' }}>
              <CardBody className="gol">
                <div className="d-flex align-items-start ">
                  <div className="avatar-sm font-size-20 me-3">

                  </div>
                  <div className="flex-1">
                    <div className="font-size-16 mt-2">CATEGORY</div>
                    <div className="font-size-16 mt-2">{data?.cat}</div>
                    <div className="font-size-16 mt-2">
                      <Link className="colud" to="/view-category">View All</Link>
                    </div>
                  </div>
                </div>


              </CardBody>
            </Card>
          </Col>
          <Col lg={3}>
            <Card style={{ height: '87%' }}>
              <CardBody className="gol">
                <div className="d-flex align-items-start">
                  <div className="avatar-sm font-size-20 me-3">
                  </div>
                  <div className="flex-1">
                    <div className="font-size-16 mt-2">PDF</div>
                    <div className="font-size-16 mt-2">{data?.pdf}</div>
                    <div className="font-size-16 mt-2">
                      <Link className="colud" to="/view-Pdf">View All</Link>
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
};

Dashboard.propTypes = {
  getProfile: PropTypes.func,
};

const mapStateToProps = (state) => {
  // console.log('state at dashboard', state);
  const { user } = state.Profile;
  return { user };
};

export default withRouter(connect(mapStateToProps, { getProfile })(Dashboard));
